import { useQuery } from '@tanstack/react-query';
import { AxiosProxy } from '../../api/axiosProxy/axiosProxy';
import { extractScoreSeverity } from '../../components/CvssScore/CvssScore';
import { ManifestBubbleChartDataType } from '../../components/ManifestCharts/ScatterBubble/types';
import { captureExceptionWithMessage } from '../../lib/sentry/captureExceptionWithMessage/captureExceptionWithMessage';

export const useFetchBubbleChartData = () => {
  const filters = [{ field: 'assetActive', value: [true] }];
  const queryParams = new URLSearchParams({ filters: JSON.stringify(filters) });

  const fetchUrl = `vulnerabilities/summary-graph/?limit=1500&severityFloor=5&sort={"preferredScore": -1, "cvss3BaseScore": -1, "cvss3BaseScore": -1}&${queryParams.toString()}`;

  return useQuery({
    queryKey: ['vulnBubbleChartData', `/${fetchUrl}`],
    queryFn: () => AxiosProxy.get({ url: fetchUrl }),
    select: (fetchData) => {
      if (fetchData && fetchData?.success && fetchData?.data) {
        const vulnsBubbleCriticalData: ManifestBubbleChartDataType[] = [];
        const vulnsBubbleHighData: ManifestBubbleChartDataType[] = [];
        const vulnsBubbleMediumData: ManifestBubbleChartDataType[] = [];
        const vulnsBubbleLowData: ManifestBubbleChartDataType[] = [];

        for (const singleVuln of fetchData?.data) {
          let { score, severity } = extractScoreSeverity(singleVuln);
          severity = `${severity || 'unknown'}`.trim().toLowerCase();
          score = score || 0;

          let epssScorePercentage = -1;
          if (singleVuln?.epssScore) {
            epssScorePercentage = Math.round(singleVuln.epssScore * 10000) / 100;
          }

          const dataArray: ManifestBubbleChartDataType = {
            x: score, // -1 in case of unexpected behavior
            y: epssScorePercentage, // -1 in case of unexpected behavior
            z: singleVuln?.countAffectedAssets, // Size, determined by number of affected assets
            context: singleVuln,
          };

          switch (severity) {
            case 'critical':
              vulnsBubbleCriticalData.push(dataArray);
              break;
            case 'high':
              vulnsBubbleHighData.push(dataArray);
              break;
            case 'medium':
              vulnsBubbleMediumData.push(dataArray);
              break;
            case 'low':
              vulnsBubbleLowData.push(dataArray);
              break;
            default:
              captureExceptionWithMessage(
                'Skipping assignment for an unknown CVSS base severity!',
              );

              break;
          }
        }

        return {
          vulnsBubbleCriticalData,
          vulnsBubbleHighData,
          vulnsBubbleMediumData,
          vulnsBubbleLowData,
        };
      }
    },
  });
};
